import accordionSlotRecipe from './Accordion.recipe.ts';
import actionBarSlotRecipe from './ActionBar.recipe.ts';
import alertSlotRecipe from './Alert.recipe.ts';
import avatarSlotRecipe from './Avatar.recipe.ts';
import breadcrumbSlotRecipe from './Breadcrumb.recipe.ts';
import cardSlotRecipe from './Card.recipe';
import checkboxSlotRecipe from './Checkbox.recipe';
import codeSnippetSlotRecipe from './CodeSnippet.recipe.ts';
import collapsibleSlotRecipe from './Collapsible.recipe.ts';
import comboboxSlotRecipe from './Combobox.recipe.ts';
import dataWidgetSlotRecipe from './DataWidget.recipe.ts';
import datePickerSlotRecipe from './DatePicker.recipe.ts';
import datePickerSelectSlotRecipe from './DatePickerSelect.recipe.ts';
import dialogSlotRecipe from './Dialog.recipe.ts';
import draggableCardSlotRecipe from './DraggableCard.recipe.ts';
import drawerSlotRecipe from './Drawer.recipe.ts';
import emptyStateSlotRecipe from './EmptyState.recipe';
import expandableCardSlotRecipe from './ExpandableCard.recipe.ts';
import fieldSlotRecipe from './Field.recipe';
import fieldsetSlotRecipe from './Fieldset.recipe.ts';
import fileUploadSlotRecipe from './FileUpload.recipe.ts';
import groupHeadingSlotRecipe from './GroupHeading.recipe.ts';
import imageCropperSlotRecipe from './ImageCropper.recipe.ts';
import inlineLoadingSlotRecipe from './InlineLoading.recipe.ts';
import labeledDataSlotRecipe from './LabeledData.recipe.ts';
import listSlotRecipe from './List.recipe.ts';
import markdownSlotRecipe from './Markdown.recipe.ts';
import markdownCardSlotRecipe from './MarkdownCard.recipe.ts';
import menuSlotRecipe from './Menu.recipe.ts';
import multiselectSlotRecipe from './Multiselect.recipe.ts';
import nativeSelectSlotRecipe from './NativeSelect.recipe.ts';
import noteCardSlotRecipe from './NoteCard.recipe.ts';
import numberInputSlotRecipe from './NumberInput.recipe';
import overflowContentSlotRecipe from './OverflowContent.recipe.ts';
import pageFooterSlotRecipe from './PageFooter.recipe.ts';
import pageHeaderSlotRecipe from './PageHeader.recipe.ts';
import pageSidebarSlotRecipe from './PageSidebar.recipe.ts';
import paginationSlotRecipe from './Pagination.recipe.ts';
import paginationLoadMoreSlotRecipe from './PaginationLoadMore.recipe.ts';
import popoverSlotRecipe from './Popover.recipe.ts';
import progressSlotRecipe from './Progress.recipe.ts';
import qrCodeSlotRecipe from './QrCode.recipe.ts';
import radioGroupSlotRecipe from './RadioGroup.recipe.ts';
import ribbonSlotRecipe from './Ribbon.recipe.ts';
import sectionHeadingSlotRecipe from './SectionHeading.recipe.ts';
import segmentGroupSlotRecipe from './SegmentGroup.recipe.ts';
import { selectSlotRecipe } from './Select.recipe.ts';
import settingsCardSlotRecipe from './SettingsCard.recipe.ts';
import splitButtonSlotRecipe from './SplitButton.recipe.ts';
import statSlotRecipe from './Stat.recipe.ts';
import stepCardSlotRecipe from './StepCard.recipe.ts';
import stepsSlotRecipe from './Steps.recipe.ts';
import switchSlotRecipe from './Switch.recipe';
import tableSlotRecipe from './Table.recipe.ts';
import tableCardSlotRecipe from './TableCard.recipe.ts';
import tabsSlotRecipe from './Tabs.recipe';
import tagSlotRecipe from './Tag.recipe.ts';
import tagsInputSlotRecipe from './TagsInput.recipe.ts';
import textInputSlotRecipe from './TextInput.recipe.ts';
import toastSlotRecipe from './Toast.recipe';
import toggletipSlotRecipe from './Toggletip.recipe';
import tooltipSlotRecipe from './Tooltip.recipe';
import tourSlotRecipe from './Tour.recipe.ts';
import treeViewSlotRecipe from './TreeView.recipe.ts';
import uiSideNavSlotRecipe from './UISideNav.recipe.ts';

const slotRecipes = {
  accordion: accordionSlotRecipe,
  actionBar: actionBarSlotRecipe,
  alert: alertSlotRecipe,
  avatar: avatarSlotRecipe,
  breadcrumb: breadcrumbSlotRecipe,
  card: cardSlotRecipe,
  checkbox: checkboxSlotRecipe,
  codeSnippet: codeSnippetSlotRecipe,
  collapsible: collapsibleSlotRecipe,
  combobox: comboboxSlotRecipe,
  dataWidget: dataWidgetSlotRecipe,
  datePicker: datePickerSlotRecipe,
  datePickerSelect: datePickerSelectSlotRecipe,
  dialog: dialogSlotRecipe,
  draggableCard: draggableCardSlotRecipe,
  drawer: drawerSlotRecipe,
  emptyState: emptyStateSlotRecipe,
  expandableCard: expandableCardSlotRecipe,
  field: fieldSlotRecipe,
  groupHeading: groupHeadingSlotRecipe,
  fieldset: fieldsetSlotRecipe,
  fileUpload: fileUploadSlotRecipe,
  imageCropper: imageCropperSlotRecipe,
  inlineLoading: inlineLoadingSlotRecipe,
  list: listSlotRecipe,
  markdown: markdownSlotRecipe,
  markdownCard: markdownCardSlotRecipe,
  menu: menuSlotRecipe,
  multiselect: multiselectSlotRecipe,
  noteCard: noteCardSlotRecipe,
  nativeSelect: nativeSelectSlotRecipe,
  numberInput: numberInputSlotRecipe,
  overflowContent: overflowContentSlotRecipe,
  pageFooter: pageFooterSlotRecipe,
  pageHeader: pageHeaderSlotRecipe,
  pageSidebar: pageSidebarSlotRecipe,
  pagination: paginationSlotRecipe,
  paginationLoadMore: paginationLoadMoreSlotRecipe,
  popover: popoverSlotRecipe,
  progress: progressSlotRecipe,
  qrCode: qrCodeSlotRecipe,
  radioGroup: radioGroupSlotRecipe,
  ribbon: ribbonSlotRecipe,
  sectionHeading: sectionHeadingSlotRecipe,
  labeledData: labeledDataSlotRecipe,
  segmentGroup: segmentGroupSlotRecipe,
  select: selectSlotRecipe,
  settingsCard: settingsCardSlotRecipe,
  splitButton: splitButtonSlotRecipe,
  stat: statSlotRecipe,
  stepsCard: stepCardSlotRecipe,
  steps: stepsSlotRecipe,
  switch: switchSlotRecipe,
  table: tableSlotRecipe,
  tableCard: tableCardSlotRecipe,
  tabs: tabsSlotRecipe,
  tag: tagSlotRecipe,
  tagsInput: tagsInputSlotRecipe,
  textInput: textInputSlotRecipe,
  toast: toastSlotRecipe,
  toggletip: toggletipSlotRecipe,
  tooltip: tooltipSlotRecipe,
  tour: tourSlotRecipe,
  treeView: treeViewSlotRecipe,
  uiSideNav: uiSideNavSlotRecipe,
};

export default slotRecipes;
